import { render, staticRenderFns } from "./DocumentCard.vue?vue&type=template&id=60699255&scoped=true&"
import script from "./DocumentCard.vue?vue&type=script&lang=ts&"
export * from "./DocumentCard.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentCard.vue?vue&type=style&index=0&id=60699255&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60699255",
  null
  
)

export default component.exports